window.addEventListener("load", function() {
    if ($("#swiperCharacter").length > 0) {
        // Function to load images

        const thumbsSwiper = new Swiper("#swiperCharacterThumb", {
            slidesPerView: 3,
            spaceBetween: 10,
            // centeredSlides: true,
            slideToClickedSlide: true,
            breakpoints: {
                751: {
                    slidesPerView: 4,
                }
            },
        });

        const mainSwiper = new Swiper("#swiperCharacter", {
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 0,
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            thumbs: {
                swiper: thumbsSwiper,
            },
            navigation: {
                nextEl: ".swiper-button-next--swiperCharacter",
                prevEl: ".swiper-button-prev--swiperCharacter",
            },
        });
    }
    $(".btn__more").on("click", function(e) {
        $(".popup_coming").addClass("active");
    });
});